import AxiosInstance from "./AxiosInstance";

// Get All Destinations
export const getAllInquiryDetails = async () => {
  try {
    const { data } = await AxiosInstance.get("/inquiry_details");
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const createInquiryDetails = async (inquiryDetails) => {
  try {
    const { data } = await AxiosInstance.post(
      "/inquiry_details",
      inquiryDetails
    );
    return data;
  } catch (error) {
    console.log(error);
  }
};
